import { createSlice } from '@reduxjs/toolkit'

import { post } from 'state/thunks/move'

const initialState = {
  response: {
    TotalCount: 0,
    Items: []
  },
  move: {},
  loading: false,
  success: false,
  error: null
}

const moveSlice = createSlice({
  name: 'move',
  initialState,
  reducers: {
    clear: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(post.pending, state => {
      state.loading = true
    })

    builder.addCase(post.fulfilled, (state, action) => {
      state.move = action.payload
      state.loading = false
      state.success = true
      state.error = null
    })

    builder.addCase(post.rejected, (state, action) => {
      state.loading = false
      state.success = false
      state.error = action.payload
    })
  }
})

export const actions = {
  ...moveSlice.actions,
  post
}

export const reducer = moveSlice.reducer
